import { useQueryClient } from '@tanstack/vue-query';

export default function useInvalidatePaginated() {
  const queryClient = useQueryClient();

  const invalidateQuery = (queryKey) => {
    const queryData = queryClient.getQueryData(queryKey);
    const firstPageData = queryData?.pages?.at(0);

    if (queryData) {
      queryClient.setQueryData(queryKey, {
        pageParams: [{ pageParams: 1 }],
        pages: [firstPageData],
      });
    }

    queryClient.invalidateQueries({ queryKey });
  };

  return { invalidateQuery };
}
